// @ts-nocheck

import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  OnDestroy,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';

import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs';
import { ListItem } from '@ispm/widgets/models/list-item';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'ispm-selectable-item',
  templateUrl: './selectable-item.component.html',
  styleUrls: ['./selectable-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectableItemComponent implements OnInit, OnDestroy {

  @Output() selectedItemEmitter = new EventEmitter<any>();

  @Input()
  public item$: BehaviorSubject<ListItem> = new BehaviorSubject<ListItem>(null);

  public selectedOption: { id: string, name: string};

  private destroyed$: Subject<any> = new Subject();
  private item: ListItem;

  guestForm = new FormGroup({
    defaultItem: new FormControl((!!this.item) ? { id: 'Select', name: 'Select'} : this.item),
  });

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  ngOnInit() {
    this.item = null;
    this.item$.takeUntil(this.destroyed$.asObservable())
      .subscribe(data => {
        if (!!data) {
          this.item = data;
        }
      });
  }

  handleSelection() {
    this.selectedItemEmitter.emit(this.selectedOption);
  }
}
